/*eslint-disable*/
export default {
    "id": "3018451",
    "name": "1230_pc",
    "font_family": "lcp-icon",
    "css_prefix_text": "pc-",
    "description": "",
    "glyphs": [
        {
            "icon_id": "29749064",
            "name": "加载中",
            "font_class": "loading",
            "unicode": "e600",
            "unicode_decimal": 58897
        },
        {
            "icon_id": "29749064",
            "name": "左转",
            "font_class": "rotate-left",
            "unicode": "e611",
            "unicode_decimal": 58897
        },
        {
            "icon_id": "29749068",
            "name": "右转",
            "font_class": "rotate-right",
            "unicode": "e612",
            "unicode_decimal": 58898
        },
        {
            "icon_id": "29749063",
            "name": "缩小",
            "font_class": "zoomout",
            "unicode": "e610",
            "unicode_decimal": 58896
        },
        {
            "icon_id": "29749059",
            "name": "放大",
            "font_class": "zoomin",
            "unicode": "e60f",
            "unicode_decimal": 58895
        },
        {
            "icon_id": "28533947",
            "name": "新增文件",
            "font_class": "folder-add",
            "unicode": "e665",
            "unicode_decimal": 58981
        },
        {
            "icon_id": "28533948",
            "name": "上方向",
            "font_class": "up",
            "unicode": "e666",
            "unicode_decimal": 58982
        },
        {
            "icon_id": "28533949",
            "name": "下方向",
            "font_class": "down",
            "unicode": "e667",
            "unicode_decimal": 58983
        },
        {
            "icon_id": "28533950",
            "name": "右方向",
            "font_class": "right",
            "unicode": "e668",
            "unicode_decimal": 58984
        },
        {
            "icon_id": "28533951",
            "name": "文件夹",
            "font_class": "folder",
            "unicode": "e669",
            "unicode_decimal": 58985
        },
        {
            "icon_id": "28533952",
            "name": "左方向",
            "font_class": "left",
            "unicode": "e66a",
            "unicode_decimal": 58986
        },
        {
            "icon_id": "28533953",
            "name": "地图",
            "font_class": "map",
            "unicode": "e66b",
            "unicode_decimal": 58987
        },
        {
            "icon_id": "28533954",
            "name": "定位",
            "font_class": "position",
            "unicode": "e66c",
            "unicode_decimal": 58988
        },
        {
            "icon_id": "28533955",
            "name": "缺陷",
            "font_class": "bug",
            "unicode": "e66d",
            "unicode_decimal": 58989
        },
        {
            "icon_id": "28533945",
            "name": "双左箭头",
            "font_class": "d-left-arrow",
            "unicode": "e663",
            "unicode_decimal": 58979
        },
        {
            "icon_id": "28533946",
            "name": "双右箭头",
            "font_class": "d-right-arrow",
            "unicode": "e664",
            "unicode_decimal": 58980
        },
        {
            "icon_id": "27976277",
            "name": "组织架构",
            "font_class": "organization",
            "unicode": "e65d",
            "unicode_decimal": 58973
        },
        {
            "icon_id": "27918237",
            "name": "卡片视图",
            "font_class": "display-card",
            "unicode": "e63d",
            "unicode_decimal": 58941
        },
        {
            "icon_id": "27918238",
            "name": "清空",
            "font_class": "clear",
            "unicode": "e64c",
            "unicode_decimal": 58956
        },
        {
            "icon_id": "27918239",
            "name": "数据报告",
            "font_class": "data-report",
            "unicode": "e654",
            "unicode_decimal": 58964
        },
        {
            "icon_id": "27918240",
            "name": "时间升序",
            "font_class": "order-asc",
            "unicode": "e655",
            "unicode_decimal": 58965
        },
        {
            "icon_id": "27918241",
            "name": "列表视图",
            "font_class": "list-display",
            "unicode": "e656",
            "unicode_decimal": 58966
        },
        {
            "icon_id": "27918242",
            "name": "时间降序",
            "font_class": "order-desc",
            "unicode": "e657",
            "unicode_decimal": 58967
        },
        {
            "icon_id": "27918243",
            "name": "统计图表",
            "font_class": "chart",
            "unicode": "e658",
            "unicode_decimal": 58968
        },
        {
            "icon_id": "27918244",
            "name": "安全",
            "font_class": "safe",
            "unicode": "e659",
            "unicode_decimal": 58969
        },
        {
            "icon_id": "27918245",
            "name": "数据分析",
            "font_class": "data-analysis",
            "unicode": "e65a",
            "unicode_decimal": 58970
        },
        {
            "icon_id": "27918246",
            "name": "用户信息",
            "font_class": "user-info",
            "unicode": "e65b",
            "unicode_decimal": 58971
        },
        {
            "icon_id": "27918247",
            "name": "字母升序",
            "font_class": "word-order-asc",
            "unicode": "e65c",
            "unicode_decimal": 58972
        },
        {
            "icon_id": "27918249",
            "name": "用户群组",
            "font_class": "user-group",
            "unicode": "e65e",
            "unicode_decimal": 58974
        },
        {
            "icon_id": "27918250",
            "name": "数据展示",
            "font_class": "data-display",
            "unicode": "e65f",
            "unicode_decimal": 58975
        },
        {
            "icon_id": "27918251",
            "name": "数据分类",
            "font_class": "data-class",
            "unicode": "e660",
            "unicode_decimal": 58976
        },
        {
            "icon_id": "27918252",
            "name": "设置",
            "font_class": "setting",
            "unicode": "e661",
            "unicode_decimal": 58977
        },
        {
            "icon_id": "27918253",
            "name": "字母降序",
            "font_class": "word-order-desc",
            "unicode": "e662",
            "unicode_decimal": 58978
        },
        {
            "icon_id": "27336423",
            "name": "创建",
            "font_class": "create",
            "unicode": "e617",
            "unicode_decimal": 58903
        },
        {
            "icon_id": "26661904",
            "name": "刷新",
            "font_class": "refresh",
            "unicode": "e60c",
            "unicode_decimal": 58892
        },
        {
            "icon_id": "26587645",
            "name": "下载",
            "font_class": "download",
            "unicode": "e60b",
            "unicode_decimal": 58891
        },
        {
            "icon_id": "26587643",
            "name": "上传",
            "font_class": "upload",
            "unicode": "e609",
            "unicode_decimal": 58889
        },
        {
            "icon_id": "26558404",
            "name": "默认",
            "font_class": "default",
            "unicode": "e606",
            "unicode_decimal": 58886
        },
        {
            "icon_id": "26506487",
            "name": "左箭头",
            "font_class": "left-arrow",
            "unicode": "e653",
            "unicode_decimal": 58963
        },
        {
            "icon_id": "26506478",
            "name": "右箭头",
            "font_class": "right-arrow",
            "unicode": "e652",
            "unicode_decimal": 58962
        },
        {
            "icon_id": "26504571",
            "name": "上箭头",
            "font_class": "top-arrow",
            "unicode": "e651",
            "unicode_decimal": 58961
        },
        {
            "icon_id": "26504566",
            "name": "下箭头",
            "font_class": "bottom-arrow",
            "unicode": "e650",
            "unicode_decimal": 58960
        },
        {
            "icon_id": "26504538",
            "name": "关闭",
            "font_class": "close",
            "unicode": "e64f",
            "unicode_decimal": 58959
        },
        {
            "icon_id": "26504331",
            "name": "添加",
            "font_class": "add",
            "unicode": "e64e",
            "unicode_decimal": 58958
        },
        {
            "icon_id": "26504287",
            "name": "搜索",
            "font_class": "search",
            "unicode": "e64d",
            "unicode_decimal": 58957
        },
        {
            "icon_id": "26504251",
            "name": "更多",
            "font_class": "more",
            "unicode": "e64b",
            "unicode_decimal": 58955
        },
        {
            "icon_id": "26504243",
            "name": "首页",
            "font_class": "home",
            "unicode": "e64a",
            "unicode_decimal": 58954
        },
        {
            "icon_id": "33769452",
            "name": "菜单",
            "font_class": "menu",
            "unicode": "e61b",
            "unicode_decimal": 58907
        },
        {
            "icon_id": "26504230",
            "name": "任务",
            "font_class": "task",
            "unicode": "e649",
            "unicode_decimal": 58953
        },
        {
            "icon_id": "26504227",
            "name": "任务失败",
            "font_class": "task-failed",
            "unicode": "e648",
            "unicode_decimal": 58952
        },
        {
            "icon_id": "26504175",
            "name": "任务成功",
            "font_class": "task-done",
            "unicode": "e647",
            "unicode_decimal": 58951
        },
        {
            "icon_id": "26504167",
            "name": "文件",
            "font_class": "file",
            "unicode": "e646",
            "unicode_decimal": 58950
        },
        {
            "icon_id": "26504151",
            "name": "日历",
            "font_class": "calendar",
            "unicode": "e645",
            "unicode_decimal": 58949
        },
        {
            "icon_id": "26504141",
            "name": "用户",
            "font_class": "user",
            "unicode": "e644",
            "unicode_decimal": 58948
        },
        {
            "icon_id": "26504114",
            "name": "编辑",
            "font_class": "edit",
            "unicode": "e643",
            "unicode_decimal": 58947
        },
        {
            "icon_id": "26504107",
            "name": "查找",
            "font_class": "find",
            "unicode": "e642",
            "unicode_decimal": 58946
        },
        {
            "icon_id": "26504090",
            "name": "复制",
            "font_class": "copy",
            "unicode": "e641",
            "unicode_decimal": 58945
        },
        {
            "icon_id": "26504083",
            "name": "数据",
            "font_class": "data",
            "unicode": "e640",
            "unicode_decimal": 58944
        },
        {
            "icon_id": "26504037",
            "name": "删除",
            "font_class": "remove",
            "unicode": "e63f",
            "unicode_decimal": 58943
        },
        {
            "icon_id": "26504030",
            "name": "保存",
            "font_class": "save",
            "unicode": "e63e",
            "unicode_decimal": 58942
        },
        {
            "icon_id": "26503937",
            "name": "时间",
            "font_class": "time",
            "unicode": "e63b",
            "unicode_decimal": 58939
        },
        {
            "icon_id": "26503500",
            "name": "提醒",
            "font_class": "info",
            "unicode": "e63a",
            "unicode_decimal": 58938
        },
        {
            "icon_id": "26503453",
            "name": "帮助",
            "font_class": "help",
            "unicode": "e639",
            "unicode_decimal": 58937
        },
        {
            "icon_id": "26503394",
            "name": "成功",
            "font_class": "success",
            "unicode": "e638",
            "unicode_decimal": 58936
        },
        {
            "icon_id": "26503372",
            "name": "失败",
            "font_class": "error",
            "unicode": "e637",
            "unicode_decimal": 58935
        },
        {
            "icon_id": "33770914",
            "name": "减少",
            "font_class": "decrease",
            "unicode": "e61e",
            "unicode_decimal": 58910
        },
        {
            "icon_id": "33770909",
            "name": "增加",
            "font_class": "add-new",
            "unicode": "e61d",
            "unicode_decimal": 58909
        },
        {
            "icon_id": "26503253",
            "name": "收藏",
            "font_class": "star",
            "unicode": "e636",
            "unicode_decimal": 58934
        },
        {
            "icon_id": "26503186",
            "name": "附件",
            "font_class": "attachment",
            "unicode": "e635",
            "unicode_decimal": 58933
        },
        {
            "icon_id": "26503172",
            "name": "通知",
            "font_class": "notice",
            "unicode": "e634",
            "unicode_decimal": 58932
        },
        {
            "icon_id": "32817276",
            "name": "拖拽",
            "font_class": "dragHandler",
            "unicode": "e624",
            "unicode_decimal": 58916
        }
    ]
}
